<template>
    <div style="background-color: blue;">
        <button v-if="!isSearching" @click="FindGame">Почати грати</button>
        <span v-else>Пошук ...</span>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios';

const isSearching = ref(false)
async function FindGame() {
    const res = await axios.get(process.env.VUE_APP_SERVER_GEKS + "/FindGame");
    isSearching.value = true
}

</script>